var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classes }, [_vm._m(0)])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "table",
      {
        ref: "table",
        class: _vm.className,
        attrs: { id: _vm.tableId, cellpadding: "0" }
      },
      [
        _c("thead", { class: _vm.theadClassName }, [
          _c(
            "tr",
            _vm._l(_vm.options.columns, function(field, i) {
              return _c(
                "th",
                { key: "head_" + i, class: field.classHeaderName },
                [_c("div", { domProps: { innerHTML: _vm._s(field.label) } })]
              )
            }),
            0
          )
        ]),
        _vm._v(" "),
        !_vm.hideTfoot
          ? _c("tfoot", { class: _vm.tfootClassName }, [
              _c(
                "tr",
                _vm._l(_vm.options.columns, function(field, i) {
                  return _c(
                    "th",
                    { key: "foot_" + i, class: field.classFooterName },
                    [
                      _vm._t(
                        "FOOT_" + field.name,
                        function() {
                          return [
                            _vm.columnSearch &&
                            (field.searchable ||
                              typeof field.searchable === "undefined")
                              ? _c("input", {
                                  class: _vm.columnSearchClassName,
                                  attrs: {
                                    placeholder: field.label,
                                    type: "search"
                                  }
                                })
                              : !_vm.columnSearch
                              ? _c("div", {
                                  domProps: { innerHTML: _vm._s(field.label) }
                                })
                              : _vm._e()
                          ]
                        },
                        { field: field, i: i }
                      )
                    ],
                    2
                  )
                }),
                0
              )
            ])
          : _vm._e()
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }